import React from 'react';
import { ShieldCheckIcon, AwardIcon } from 'lucide-react';
export function ServiceAreasSection() {
  return <section id="service-areas" className="bg-[#0B1F3A] text-white py-20" data-id="element-251">
      <div className="max-w-7xl mx-auto px-4" data-id="element-252">
        <div className="text-center mb-12" data-id="element-253">
          <h2 className="text-3xl lg:text-4xl font-bold mb-6" data-id="element-254">
            Serving Upper Marlboro & Surrounding Communities
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-255">
            We proudly serve patients across Upper Marlboro, MD and the
            surrounding areas with reliable, compassionate medical
            transportation services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-256">
          <div className="flex items-center justify-center space-x-4 bg-white bg-opacity-10 rounded-lg p-6" data-id="element-257">
            <ShieldCheckIcon className="h-12 w-12 text-[#E63946]" data-id="element-258" />
            <span className="text-xl font-semibold" data-id="element-259">Bonded & Insured</span>
          </div>
          <div className="flex items-center justify-center space-x-4 bg-white bg-opacity-10 rounded-lg p-6" data-id="element-260">
            <AwardIcon className="h-12 w-12 text-[#E63946]" data-id="element-261" />
            <span className="text-xl font-semibold" data-id="element-262">
              MD Medicaid Transportation Provider
            </span>
          </div>
        </div>
      </div>
    </section>;
}